import React, { useState } from "react";
import { DropdownItem, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import Contacts from "./Contacts";
import { proxyAPI } from "../proxyAPI";
import {
  useAssignContactsToAssetMutation,
  useGetAssetsQuery,
} from "../store/slices/mapsSlice";
import Input from "../Builder/nodes/Logic/Inputs/Input";

export default function BulkAssignAssetsModal({
  selectedContacts,
  setFilter,
  label,
}) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [replace, setReplace] = useState(false);
  const [asset, setAsset] = useState("");

  const [save] = useAssignContactsToAssetMutation();

  const handleSave = async () => {
    const data = await save({
      contactUuids: selectedContacts,
      assetUuid: asset,
      isDelete: replace,
    });

    if (data.isError) {
      toast.error(data.message);
      return;
    }
    if (data) {
      toast.success("Contacts updated successfully");
      setFilter?.((p) => [...p]);
      setShow(false);
    }
  };

  const [showContactSets, setShowContactSets] = useState([]);

  const { data: { assets } = { assets: [] } } = useGetAssetsQuery(
    {
      // page: 0,
      perPage: 1000,
      // search: "",
    },
    { skip: !show }
  );

  return (
    <>
      <DropdownItem onClick={handleShow}>
        {label || "Assign assets"}
      </DropdownItem>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Assign assets</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Input
            value={[asset]}
            onChange={([v]) => {
              setAsset(v);
            }}
            inputType="select"
            options={assets?.map((a) => ({
              value: a.Uuid,
              label: a.Label,
            }))}
          />

          <Form.Check
            label="Replace existing contacts"
            id="replace"
            checked={replace}
            onChange={(e) => setReplace(e.target.checked)}
          />

          <h5 className="mt-3">Selected contacts</h5>
          <Contacts
            useSearchOptions
            includeContacts={selectedContacts}
            contactSets={showContactSets}
            fullView={false}
          />
          <Button
            variant=""
            onClick={handleSave}
            className="bg-colored-reverse text-white fw-bold rounded-pill p-2 px-4 float-end"
          >
            Update selected contacts
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}
